import { PathRoutes } from 'common';
import LibertyChangePageButton from 'components/basics/LibertyChangePageButton/LibertyChangePageButton';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

export const SwitchRenovation = () => {
  const navigate = useNavigate();
  const optionsList = useMemo(
    () => [
      {
        name: 'Producción',
        tooltip: null,
        action: () => navigate(PathRoutes.QUERIES),
        id: 'id_to_consultation_button'
      },
      {
        name: 'Siniestros',
        action: () => navigate(PathRoutes.SINISTERS),
        id: 'id_to_sinister_button'
      },
      {
        name: 'Suplementos y anulaciones',
        action: () => navigate(PathRoutes.SUPPLEMENTS_ANNULMENTS),
        id: 'id_to_supplements_button'
      }
    ],
    [navigate]
  );

  return (
    <LibertyChangePageButton title={'Otras consultas'} options={optionsList} buttonStyles={true} />
  );
};
